export default {
  label: 'Channels',
  placeholder: 'All',
};
